"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BUILD_LANGS = exports.AVAILABLE_LANGS = exports.BuildLang = void 0;
exports.isBuildLang = isBuildLang;
exports.BuildLang = {
    RU: 'ru',
    EN: 'en',
    TR: 'tr',
    ENIE: 'en-IE',
    ZHIE: 'zh-IE',
    UZ: 'uz',
    KK: 'kk',
    ZH: 'zh',
    ZH_HANS: 'zh-Hans',
    PT: 'pt',
    ES: 'es',
};
exports.AVAILABLE_LANGS = [
    exports.BuildLang.RU,
    exports.BuildLang.EN,
    exports.BuildLang.TR,
    exports.BuildLang.ENIE,
    exports.BuildLang.KK,
    exports.BuildLang.UZ,
    exports.BuildLang.ZH_HANS,
];
exports.DEFAULT_BUILD_LANGS = [exports.BuildLang.RU, exports.BuildLang.EN, exports.BuildLang.TR];
function isBuildLang(value) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return exports.AVAILABLE_LANGS.includes(value);
}
